// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"104":"987b66bc0a23e94906ac","864":"063104f2c03c00d8eca1"}[chunkId] + ".css";
};